import React, { useContext, useState } from "react";
import { Menu, Collapse } from "antd";

import { useHistory, Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "../SidebarLogo";
import UserProfile from "../UserProfile";
import AppsNavigation from "../AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../../constants/ThemeSetting";
import IntlMessages from "../../../util/IntlMessages";
import { useSelector } from "react-redux";

import TABS from "../../../util/contexts/Tabs";

import "./index.css";
import PagesData from "../../../constants/pageData";


const Panel = Collapse.Panel;

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { tabs, setTabs } = useContext(TABS);
  const [category, setCategory] = useState([]);
  const history = useHistory();

  function addTab({ title, id, url }) {
    let tabLength = tabs.find((tab) => tab.id === id);
    if (!tabLength) {
      setTabs([...tabs, { title: title, id: id, url: url }]);
    }
    console.log(tabs);
    history.push(url);
  }

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  console.log(category);
  return (
    <>
      {/* <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      /> */}
      {/* <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        > */}
          {/* <UserProfile /> */}
          {/* <AppsNavigation /> */}
        {/* </div> */}
        {/* <CustomScrollbars className="gx-layout-sider-scrollbar ">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            {PagesData.Home.map((i) => {
              return (
                <Menu.Item key={i.id} className="menu-page-option">
                  <Link
                    className="link_option"
                    to={i.url}
                    key={i.id}
                  >
                    {i.icon}
                    {i.title}
                    </Link>
                </Menu.Item>
              );
            })}
          </Menu>
        </CustomScrollbars> */}
      {/* </div> */}
    </>
  );
};

export default React.memo(SidebarContent);

{
  /* <Link to="/financial/pay">
                  <i className="icon icon-bitcoin" />
                  <span>
                    <IntlMessages id="sidebar.financial.pay" />
                  </span>
                </Link> */
}
{
  /* <Menu.Item key="financial/pay">
              <button
                className={classes.link_option}
                onClick={() => {
                  addTab(PagesData["accounting"].lists[1]);
                }}
              >
                {PagesData["accounting"].lists[1].title}
              </button>
            </Menu.Item>
            <Menu.Item key="financial/recieve">
              <button
                className={classes.link_option}
                onClick={() => {
                  addTab(PagesData["accounting"].lists[0]);
                }}
              >
                {PagesData["accounting"].lists[0].title}
              </button>
            </Menu.Item> */
}
